<app-breadcrumb></app-breadcrumb>

<div class="card mt-3">
    <div class="card-body">
        <div class="row">
            <div class="col">
                <h5 class="mb-0">
                    <i class="far fa-file-alt fa-fw"></i>
                    안전운전요약
                </h5>
            </div>
            <div class="col-auto">
                <select class="form-control form-control-sm"
                    [(ngModel)]="selectedYear"
                    (ngModelChange)="changeYear($event)">
                    <option *ngFor="let item of listYear;" [ngValue]="item">{{item}} 년</option>
                </select>
            </div>
            <div class="col-auto">
                <select class="form-control form-control-sm"
                    [(ngModel)]="selectedMonth"
                    (ngModelChange)="changeMonth($event)">
                    <option *ngFor="let item of listMonth;" [ngValue]="item">{{item}} 월</option>
                </select>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-info" (click)="clickSearch()">
                    <i class="fas fa-sync mr-1"></i>
                    불러오기
                </button>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-5">
                <div class="w-100">
                    <div id="chart-01" style="height: 200px;"></div>
                </div>
                <div class="table-responsive mt-3">
                    <table class="table table-sm table-bordered table-hover align-items-center mb-0 text-center">
                        <tr>
                            <td>최저</td>
                            <td>최대</td>
                        </tr>
                        <tr>
                            <td>{{pointSafeMin?.dtgCarNo}} ({{pointSafeMin?.pointSafe | number:'0.0-1'}})</td>
                            <td>{{pointSafeMax?.dtgCarNo}} ({{pointSafeMax?.pointSafe | number:'0.0-1'}})</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="col d-flex flex-column align-items-stretch">
                <div class="flex-fill">
                    <table class="table table-sm table-bordered table-hover align-items-center mb-0 h-100 text-center">
                        <tr>
                            <td>운행거리(km)</td>
                            <td>운행시간</td>
                            <td>과속</td>
                            <td colspan="2">장기과속(회,시간)</td>
                        </tr>
                        <tr>
                            <td>{{sumData?.dtgDistAccumul | filterDist | number:'0.0-3'}}</td>
                            <td>{{sumData?.dtgRegDtDuration | filterSecToTime}}</td>
                            <td>{{sumData?.cntRule1}}</td>
                            <td>{{sumData?.cntRule2}}</td>
                            <td>{{sumData?.durRule2 | filterSecToTime}}</td>
                        </tr>
                    </table>
                </div>
                <div class="flex-fill pt-3">
                    <table class="table table-sm table-bordered table-hover align-items-center mb-0 h-100 text-center">
                        <tr>
                            <td>급가속</td>
                            <td>급감속</td>
                            <td>급출발</td>
                            <td>급정지</td>
                            <td>공회전(시간)</td>
                        </tr>
                        <tr>
                            <td>{{sumData?.cntRule3}}</td>
                            <td>{{sumData?.cntRule5}}</td>
                            <td>{{sumData?.cntRule4}}</td>
                            <td>{{sumData?.cntRule6}}</td>
                            <td>{{sumData?.durRule101 | filterSecToTime}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card mb-0 mt-3">
    <div class="card-body">
        <div class="d-flex align-items-center justify-content-between">
            <h5 class="mb-0">
                <i class="far fa-file-alt fa-fw"></i>
                안전운전순위
            </h5>
            <div class="text-muted">
                <i class="mdi mdi-alert-circle-outline"></i>
                <span class="ml-1">100-97 : 매우안전</span>
                <span class="mx-2">,</span>
                <span class="">97-93 : 안전</span>
                <span class="mx-2">,</span>
                <span class="">93-89 : 보통</span>
                <span class="mx-2">,</span>
                <span class="">89-85 : 위험</span>
                <span class="mx-2">,</span>
                <span class="">85-74 : 매우위험</span>
            </div>
        </div>

        <div class="table-responsive mt-3">
            <table class="table table-sm table-bordered table-hover align-items-center mb-0 text-center text-nowrap">
                <thead class="text-center">
                    <tr>
                        <th>차량번호</th>
                        <th>안전지수</th>
                        <th>운행시간(시,분,초)</th>
                        <th>운행거리(km)</th>
                        <th>과속(회)</th>
                        <th>과속(시,분,초)</th>
                        <th>장기과속(회)</th>
                        <th>장기과속(시,분,초)</th>
                        <th>급가속(회)</th>
                        <th>급감속(회)</th>
                        <th>급출발(회)</th>
                        <th>급정지(회)</th>
                        <th>공회전(시,분,초)</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="!listItem || listItem.length < 1">
                        <tr class="text-center">
                            <td colspan="13">
                                표시 할 항목이 없습니다
                            </td>
                        </tr>
                    </ng-container>
                    <ng-container *ngFor="let item of listItem | sortBy:'desc':'pointSafe';let idx = index;">
                        <tr>
                            <td>
                                <button type="button" class="btn btn-sm btn-link text-cyan">
                                    {{item.dtgCarNo}}
                                </button>
                            </td>
                            <td>
                                {{item.pointSafe | number:'0.0-1'}}
                            </td>
                            <td>
                                {{item.dtgRegDtDuration | filterSecToTime}}
                            </td>
                            <td>
                                {{(item.dtgDistAccumul) | filterDist | number:'0.0-3'}}
                            </td>
                            <td>
                                {{item.cntRule1}}
                            </td>
                            <td>
                                {{item.durRule1 | filterSecToTime}}
                            </td>
                            <td>
                                {{item.cntRule2}}
                            </td>
                            <td>
                                {{item.durRule2 | filterSecToTime}}
                            </td>
                            <th>
                                {{item.cntRule3}}
                            </th>
                            <th>
                                {{item.cntRule5}}
                            </th>
                            <th>
                                {{item.cntRule4}}
                            </th>
                            <th>
                                {{item.cntRule6}}
                            </th>
                            <th>
                                {{item.durRule101 | filterSecToTime}}
                            </th>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <div class="mt-3">
            <list-paging
                [inputPagingInfo]="pagingInfo"
                (callbackClickPageNumber)="callbackClickPageNumber($event)"
                (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
        </div>
    </div>
</div>

<div class="text-warning bg-white shadow-sm p-2 mt-3 small">
    <div class="">
        <i class="far fa-bell mr-2"></i>
        <span>자료는 1일전 까지만 집계되어 표시됩니다</span>
    </div>
    <div class="mt-2">
        <i class="far fa-bell mr-2"></i>
        <span>페이지 진입시 데이터가 자동으로 표시되지 않으며 검색버튼을 눌러야 표시됩니다</span>
    </div>
</div>